import { BaseDto, OrderByValue } from '../../core';

export class CartListDto extends BaseDto<CartListDto> {
  constructor(partial?: any) {
    super(partial);
  }
  cartIds?: number[];
  shippingServiceId?: number;
  orderById?: OrderByValue;
  orderByEnglishName?: OrderByValue;
  orderByBrandId?: OrderByValue;
}
